import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { MovementPatternProvider } from "presentation/store/MovementPattern/MovementPatternProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import MovementPatternMaintenance from "presentation/view/section/MovementPattern/MovementPatternMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const MovementPatternContMain = () => {
    return <ANAInfoWrapper permission={Permission.MOVEMENT_PATTERN_MAINTENANCE}>
        <MessageBarWrapper>
            <MovementPatternProvider>
                <GridStyles/>
                <MovementPatternMaintenance/>
            </MovementPatternProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default MovementPatternContMain;